module.exports = __webpack_public_path__ + "static/media/solo-corte-v2.41f3bf05.png";